var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c("transition", { attrs: { name: "modal" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            {
              staticClass: "modal-wrapper",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.toggle($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "modalContainer",
                  staticClass: "modal-container rounded"
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h3", { staticClass: "heading-text flex-grow" }, [
                      _vm._v(_vm._s(_vm.heading))
                    ]),
                    _vm._v(" "),
                    _vm.timesButton
                      ? _c(
                          "button",
                          {
                            staticClass: "button small-rounded",
                            on: { click: _vm.toggle }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [_vm._t("default")],
                    2
                  )
                ]
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4373dfc5", { render: render, staticRenderFns: staticRenderFns })
  }
}